import React, { useImperativeHandle } from "react";
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import { FormControlLabel, } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';


const useStylesLocal = makeStyles({
  ctl_check: {
    padding: '0px 0 0px 2px', // Mantenemos el padding-top bajo para el texto
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', // flex-start para que el texto esté arriba
    cursor: 'default',
    textAlign: 'left',
    //background: 'var(--ibs_color_gray_light)',
    fontSize: 'var(--ibs_control_label_font_size_state)',
    "&.MuiFormControlLabel-root": {
      margin: '0px 0px 0px 0px',
      width: props => {
        if (props.width) {
          return props.width;
        } else {
          return '100%'
        }
      },
    },
    "& .MuiTypography-body1": {
      textAlign: 'left',
      margin: '0px 0px 0px 0px', // para el texto
      fontSize: props => { return props.fontSize || 'var(--ibs_control_label_font_size_state)' },
      width: props => { return props.itemWidth || '100%' },
    },
    // CLAVE: ESTILO PARA EL CHECKBOX (O SU CONTENEDOR)
    // Apuntamos al contenedor del checkbox, que es `label.ibs_checkbox` en tu JSX
    "& .ibs_checkbox": {
        // Opción 1: Usar margin-top positivo
        marginTop: '1px', // Ajusta este valor para mover el checkbox hacia abajo
    },
  },
});

const CxCheck = props => {
  const { onClick, ...rest } = props;
  const [label, setLabel] = React.useState(rest.label||'');
  const classesL = useStylesLocal(props);

  const [myValue, setMyValue] = React.useState(false);
  
  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const doClick = (e) => {
    // Forzamos el valor a booleano usando !! o una comparación explícita
    const isChecked = Boolean(e.target.checked);
    setMyValue(isChecked);
    
    if (onClick) {
      onClick(isChecked);
    }
  };

  useImperativeHandle(props.xref, () => {
    return {
      getType, setLabel, getVal, 
    };
  });
  const getType = () => { return 'CxCheck' };
  const getVal = () => { return myValue };

  return (
    <div>
      <FormControlLabel classes={{ root: classesL.ctl_check, }}
        label={label}
        labelPlacement="start"
        control={
          <label className="ibs_checkbox">
            <input type="checkbox" defaultChecked={false} onChange={(e) => doClick(e)} />
          </label>
        }
      />

    </div>
  );

};

export default CxCheck;
